// App Imports
import { SET_USER } from '../types';

// Emit set user event
export default function loginSetUser(token, user) {
  return { type: SET_USER, user };
}
